import { render, staticRenderFns } from "./PrescriptionsListComponent.vue?vue&type=template&id=5feebe80&scoped=true"
import script from "./PrescriptionsListComponent.vue?vue&type=script&lang=ts"
export * from "./PrescriptionsListComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feebe80",
  null
  
)

export default component.exports